import { JSX } from "react";

interface ClaimsCellProps {
  readonly claims: string[];
}
export function ClaimsCell({ claims }: ClaimsCellProps): JSX.Element {
  return (
    <div className="flex gap-xs">
      {claims.map((claim) => {
        const claimParts = claim.split(" ");
        const tagMode = claimParts.length === 1 ? "emphasis" : "subtle";
        const claimType = claimParts[0];
        const color = CLAIM_TYPE_COLORS[claimType] ?? "blue";

        return (
          <tractie-tag
            key={claim}
            color={color}
            appearance={tagMode === "subtle" ? "subtle" : undefined}
            size="l"
          >
            {claim.toUpperCase()}
          </tractie-tag>
        );
      })}
    </div>
  );
}

type TagColors = "gray" | "blue" | "green" | "orange" | "red" | "yellow" | "purple" | "pink";

const CLAIM_TYPE_COLORS: Record<string, TagColors> = {
  DCR: "yellow",
  DR: "blue",
  GDST: "red",
  OND: "green",
  TBVOND: "purple",
  VAKANT: "gray",
  DCW: "pink",
  RDL: "orange",
};
